// Derives the dashboard origin (host part of the URL) from the configured API
// URL. The widget never gets the dashboard origin directly — it's the api URL
// with the trailing `/api` segment stripped.
//
// We trim first so stray whitespace (newlines from misconfigured env vars,
// copy-paste artefacts in data-api-url, etc.) doesn't block the anchored
// `/api` strip below.
export function dashboardOriginFrom(apiUrl: string): string {
  return apiUrl.trim().replace(/\/api\/?$/, '');
}

// Defensive normalisation applied to PINMERGE_API_URL / data-api-url before
// the widget uses it. Two cleanups:
//
//   1. Strip stray whitespace (Vercel's dashboard UI has been observed to bake
//      a trailing '\n' into env-var values).
//   2. Strip a `www.` host prefix. pinmerge.com is apex-canonical (see
//      docs/decisions.md) and Vercel 308-redirects `www.pinmerge.com` → apex.
//      Browsers do NOT carry `Access-Control-Allow-Origin` across cross-origin
//      redirects, so every fetch from the widget to `www.…/api/…` dies with a
//      misleading "Failed to fetch" CORS error. Normalising here means a
//      typo'd env var still ships a working bundle.
export function normaliseApiUrl(apiUrl: string): string {
  return apiUrl
    .trim()
    .replace(/^(https?:\/\/)www\.([^/]+)/i, '$1$2')
    .replace(/\/$/, '');
}
